<script>
	import { Router, Route } from 'svelte-routing'
	import { fade } from "svelte/transition"

    import Home from './Home.svelte'
	import List from './List.svelte'
	import Detail from './Detail.svelte'
	import Play from './Play.svelte'
	import Write from './Write.svelte'
	import Bookmark from './Bookmark.svelte'
	import NotFound from './NotFound.svelte'

	import ModalCoffee from '../page/side/modalCoffee.svelte'

	export let url = '';
</script>

<Router {url} >
	<Route path="/" component={Home}></Route>

	<Route path="/list" >
		<List Page=1 />
	</Route>
	<Route path="/list/:page" let:params>
		<List Page='{params.page}' />
	</Route>

	<Route path="/detail/:num" let:params>
		<Detail Num='{params.num}' />
	</Route>

	<Route path="/play/:num" let:params>
		<Play Num='{params.num}' />
	</Route>

	<Route path="/create" >
		<Write Num=-1 />
	</Route>

	<Route path="/edit/:num" let:params>
		<Write Num='{params.num}' />
	</Route>

	<Route path="/bookmark" component={Bookmark}></Route>

	<Route path="*" component="{NotFound}" />
</Router>

<ModalCoffee />